export const getMaxColumnIndex = (items = []) =>
  Math.max(...items.map((i) => i.colIndex), 0);

export const getAverageColumnsWidthRatio = (items = []) => {
  const columnCount = getMaxColumnIndex(items) + 1;
  return Array(columnCount).fill(1 / columnCount);
};

// const minWidth = 0.125;
export const calculateColumnsWidthRatioOnAdd = (previousColumnWidth = []) =>
  // let result = [...previousColumnWidth];
  // // scale column width proportionally
  // const scaleRatio =
  //   previousColumnWidth?.length / (previousColumnWidth?.length + 1);
  // result = result.map((i) => i * scaleRatio);
  // result.push(1 - result.reduce((cur, sum) => cur + sum, 0));
  //
  // // the minimal width ratio needs to be 25%
  // const ratioInsufficient = result.some((i) => i < minWidth);
  // if (ratioInsufficient) {
  //   // assume the new added column width is 25%, then rearrange rest width for previous columns
  //   let remainRatio = 1 - minWidth;
  //   let totalOldWidthRatio = previousColumnWidth.reduce((cur, sum) => cur + sum, 0);
  //   result = [...previousColumnWidth];
  //   for (let i = 0; i < result; i++) {
  //     result[i] = remainRatio * (result[i] / totalOldWidthRatio);
  //     if(result[i] < minWidth) {
  //       result[i] = minWidth;
  //       remainRatio -= minWidth;
  //       totalOldWidthRatio -= result[i];
  //     }
  //   }
  //   result.push(minWidth);
  // }

  new Array(previousColumnWidth.length + 1).fill(
    1 / (previousColumnWidth.length + 1),
  );

// return result;
